import { useFormikContext } from 'formik';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../../atoms/Button';
import './style.scss';

const Navigation = ({
  nextStepLabel,
  onPreviousStepClick,
  isLoading,
  isDisabled,
}: {
  nextStepLabel: ReactNode;
  onPreviousStepClick?: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}) => {
  const { submitForm, isSubmitting } = useFormikContext();
  return (
    <div className="navigation-section">
      <div>
        {onPreviousStepClick && (
          <div
            className="navigation-section__previous-step"
            onClick={onPreviousStepClick}
            data-test-id="navigation-previous-step"
          >
            <FormattedMessage id="generic.previousStep" />
          </div>
        )}
      </div>
      <Button
        type="button"
        onClick={() => submitForm()}
        className="navigation-section__next-step"
        disabled={isSubmitting || isLoading || isDisabled}
        data-test-id="navigation-next-step"
        isLoading={isSubmitting || isLoading}
      >
        {nextStepLabel}
      </Button>
    </div>
  );
};

export default Navigation;
